export var readFile = function readFile(file, callback) {
  var reader = new FileReader();
  reader.onload = function (e) {
    return callback(e.target.result);
  };
  reader.readAsDataURL(file);
};